import * as React from 'react';

import { OfferCardContainer } from '../../../../common/containers/OfferCardContainer';
import { OfferProvider } from '../../../../common/containers/OfferCardContainer/OfferCardContext';
import { IDailyRentOfferForMobileSite } from '../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { AdfoxListingBanner } from '../../Adfox/AdfoxListingBanner';
import { AdfoxListingBannerWrapper } from '../../Adfox/AdfoxListingBannerWrapper';

interface ISearchResultsSuccessProps {
  offers: IDailyRentOfferForMobileSite[];
}

export const SearchResultsSuccessContainer = ({ offers }: ISearchResultsSuccessProps) => {
  const position = offers.length + 1;
  const lastOffer = offers[offers.length - 1];

  return (
    <>
      {offers.map((offer, index, offers) => (
        <OfferProvider key={offer.id} offer={offer} offerPosition={index + 1} offersLength={offers?.length}>
          <OfferCardContainer />
        </OfferProvider>
      ))}
      <AdfoxListingBannerWrapper>
        <AdfoxListingBanner
          offer={lastOffer}
          params={{ p1: 'dciqj', p2: 'fkhj' }}
          bannerType="tgb"
          position={position}
        />
      </AdfoxListingBannerWrapper>
    </>
  );
};
